import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserCulture } from 'owa-session-store';

export default function isSmartComposeEnabled(): boolean {
    const userCulture = getUserCulture();
    return (
        isFeatureEnabled('mc-smartCompose') &&
        (userCulture === 'en-US' ||
            userCulture === 'en-CA' ||
            userCulture === 'en-AU' ||
            userCulture === 'en-GB' ||
            userCulture === 'en-NZ')
    );
}
